import apiClient from "../../../api/apiClient";

// ================= GET ALL =================

export const getScaleModelsApi = async (
  page: number,
  pageSize: number,
  search: string,
  tenantId: string
) => {

  const res = await apiClient.get(
    "/operation/scale-models",
    {
      params: {
        PageNumber: page,
        PageSize: pageSize,
        Search: search,
        tenantId
      }
    }
  );

  return res.data;
};

// ================= GET ONE =================

export const getScaleModelByIdApi = async (
  id: string,
  tenantId: string
) => {

  const res = await apiClient.get(
    `/operation/scale-models/${id}`,
    {
      params: {
        tenantId
      }
    }
  );

  return res.data;
};

// ================= CREATE =================

export const createScaleModelApi = async (
  data: any,
  tenantId: string
) => {

  const res = await apiClient.post(
    "/operation/scale-models",
    data,
    {
      params: {
        tenantId
      }
    }
  );

  return res.data;
};

// ================= UPDATE =================

export const updateScaleModelApi = async (
  data: any
) => {

  const res = await apiClient.put(
    "/operation/scale-models",
    data
  );

  return res.data;
};

// ================= DELETE =================

export const deleteScaleModelApi = async (
  id: string,
  tenantId: string
) => {

  const res = await apiClient.delete(
    `/operation/scale-models/${id}`,
    {
      params: {
        tenantId
      }
    }
  );

  return res.data;
};

export const getScaleMakesApi =
  async (
    page: number,
    pageSize: number,
    search: string,
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        "/operation/scale-makes",
        {
          params: {
            PageNumber: page,
            PageSize: pageSize,
            Search: search,
            TenantId: tenantId
          }
        });

    return res.data;
  };

export const getUnitsApi =
  async (
    tenantId: string
  ) => {

    const res =
      await apiClient.get(
        "/operation/scales/units",
        {
          params: {
            PageNumber: 1,
            PageSize: 1000,
            tenantId
          }
        });

    return res.data;
  };

  // ================= GET MODELS BY MAKE =================

export const getScaleModelsByMakeApi = async (
  makeId: string,
  tenantId: string
) => {

  const res = await apiClient.get(
    `/operation/scale-models/by-make/${makeId}`,
    {
      params: {
        tenantId
      }
    }
  );

  return res.data;
};

// ================= GET CAPACITIES BY MODEL =================

export const getModelCapacitiesApi = async (
  modelId: string,
  tenantId: string
) => {

  const res = await apiClient.get(
    `/operation/scale-models/capacities/${modelId}`,
    {
      params: {
        tenantId
      }
    }
  );

  return res.data;
};
